import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Ticket, UserRoundX } from 'lucide-react';
import { Button, DefaultTooltip } from 'twyne-new.ui'

import DefaultActions from '@/components/Grid/components/header/Actions';
import { useGrid } from '@Components/Grid/context';

export default function HeaderButtons() {
  const { definitions: { entityNameModule, entityNamePlural, basePath } } = useGrid()

  const path = useMemo(() => {
    if (basePath) {
      return basePath;
    }

    return `/${entityNameModule}/${entityNamePlural.toLowerCase()}`
  }, [basePath, entityNamePlural, entityNameModule])

  return <DefaultActions>
    <DefaultTooltip content='Contests Finished' side='top'>
      <Link to={`${path}/sweep/finished`}>
        <Button color='accent' variant='outline' size='lg' className='p-0 px-3! h-full flex items-center'>
          <Ticket size={24} />
        </Button>
      </Link>
    </DefaultTooltip>
    <DefaultTooltip content='Unsubscribe' side='top'>
      <Link to={`${path}/unsubscribe`}>
        <Button color='accent' variant='outline' size='lg' className='p-0 px-3! h-full flex items-center'>
          <UserRoundX size={22} />
        </Button>
      </Link>
    </DefaultTooltip>
  </DefaultActions>
}
